import { render, staticRenderFns } from "./VideoPerformanceTable.vue?vue&type=template&id=e16c3d88&scoped=true"
import script from "./VideoPerformanceTable.vue?vue&type=script&lang=js"
export * from "./VideoPerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./VideoPerformanceTable.vue?vue&type=style&index=0&id=e16c3d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16c3d88",
  null
  
)

export default component.exports